const HIGHLIGHT_CLASS = 'LeadMessageItem--highlight';

// Прокрутка истории к сообщению с подсветкой в стиле Telegram. Одна точка на
// два сценария: клик по превью ответа и клик по закреплённому плееру.
export const scrollToLeadMessage = (
  container: HTMLElement | null,
  messageId: number | string
): void => {
  const target = container?.querySelector<HTMLElement>(
    `[data-message-id="${messageId}"]`
  );

  if (!target) return;

  target.scrollIntoView({ behavior: 'smooth', block: 'center' });

  target.classList.remove(HIGHLIGHT_CLASS);
  // Форсируем reflow, иначе анимация не переиграется при повторных кликах.
  void target.offsetWidth;
  target.classList.add(HIGHLIGHT_CLASS);
  target.addEventListener(
    'animationend',
    () => target.classList.remove(HIGHLIGHT_CLASS),
    { once: true }
  );
};
